export const PHONE_DISPLAY = "(11) 94137-0079";
export const PHONE_TEL = "+5511941370079";
export const PHONE_RAW = "5511941370079";
export const WHATSAPP_2_DISPLAY = "(11) 94358-6769";
export const WHATSAPP_2_RAW = "5511943586769";
export const EMAIL = "angmisjon@gmail.com";

export const wa = (msg) =>
    `https://wa.me/${PHONE_RAW}?text=${encodeURIComponent(msg)}`;

export const DEFAULT_MSG_PT =
    "Olá! Vim pelo site da ANG Engenharia e gostaria de solicitar um orçamento.";
export const DEFAULT_MSG_EN =
    "Hi! I came from the ANG Engenharia website and would like to request a quote.";

export const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -78, duration: 1.25 });
    } else {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
};

export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1662122849254-ee3cb9f6bfa8?q=80&w=1400&auto=format&fit=crop",
    engineer:
        "https://images.unsplash.com/photo-1581092919535-7146ff1a590b?q=80&w=1200&auto=format&fit=crop",
    voltage:
        "https://images.unsplash.com/photo-1536418376156-ce59f73aa838?q=80&w=1400&auto=format&fit=crop",
};

export const TI_IMAGES = [
    {
        src: "https://images.unsplash.com/photo-1629837093109-11325d6e7afd?q=80&w=900&auto=format&fit=crop",
    },
    {
        src: "https://images.unsplash.com/photo-1785682117028-6fcf2c0b515b?q=80&w=900&auto=format&fit=crop",
    },
    {
        src: "https://images.unsplash.com/photo-1604754742629-3e5728249d73?q=80&w=900&auto=format&fit=crop",
    },
];
